import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, CheckCircleIcon, DollarSignIcon, ClockIcon, BadgeCheckIcon, ShieldCheckIcon } from 'lucide-react';
import CountUp from 'react-countup';
import { FundingForm } from './FundingForm';
import { Logo } from './Logo';
export const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);
  const features = [{
    icon: <CheckCircleIcon className="h-6 w-6 text-[#c9a875]" data-id="element-416" />,
    text: 'No Credit Check Required'
  }, {
    icon: <ClockIcon className="h-6 w-6 text-[#c9a875]" data-id="element-417" />,
    text: 'Same-Day Funding Available'
  }, {
    icon: <DollarSignIcon className="h-6 w-6 text-[#c9a875]" data-id="element-418" />,
    text: '100% Funding for Wholesalers'
  }, {
    icon: <BadgeCheckIcon className="h-6 w-6 text-[#c9a875]" data-id="element-419" />,
    text: 'EMD & Double Closing Specialists'
  }, {
    icon: <ShieldCheckIcon className="h-6 w-6 text-[#c9a875]" data-id="element-420" />,
    text: 'Zero Paperwork Hassle'
  }];
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
      }, 50);
    }
    setIsVisible(true);
    const featureInterval = setInterval(() => {
      setActiveFeature(prev => (prev + 1) % features.length);
    }, 3000);
    return () => {
      clearInterval(featureInterval);
    };
  }, [features.length]);
  return <div className="relative w-full overflow-hidden bg-[#f2efeb]" data-id="element-421">
      {/* Navigation — dark pill on cream */}
      <nav className="absolute top-0 left-0 w-full z-50 py-6 px-4 sm:px-6 lg:px-8" data-id="element-422">
        <div className="max-w-7xl mx-auto flex justify-between items-center bg-[#2b2826] backdrop-blur-md py-3 px-6 rounded-full border border-[#2b2826] shadow-lg" data-id="element-423">
          <Logo variant="light" data-id="element-424" />

          <div className="hidden md:flex items-center gap-8" data-id="element-425">
            <a href="#services" className="text-[#f2efeb] font-medium hover:text-[#c9a875] transition-colors" data-id="element-426">
              Services
            </a>
            <a href="#process" className="text-[#f2efeb] font-medium hover:text-[#c9a875] transition-colors" data-id="element-427">
              How It Works
            </a>
            <a href="/blog" className="text-[#f2efeb] font-medium hover:text-[#c9a875] transition-colors" data-id="element-428">
              Blog
            </a>
            <a href="#funding-form" className="bg-[#c9a875] px-5 py-2.5 rounded-full text-white hover:bg-[#b08e5c] transition-all focus:outline-none focus:ring-2 focus:ring-[#c9a875]/50" data-id="element-429">
              Get Funded
            </a>
          </div>

          <div className="md:hidden" data-id="element-430">
            <a href="#funding-form" className="bg-[#c9a875] px-4 py-2 rounded-full text-white hover:bg-[#b08e5c] transition-all focus:outline-none focus:ring-2 focus:ring-[#c9a875]/50 text-sm font-medium" data-id="element-431">
              Get Funded
            </a>
          </div>
        </div>
      </nav>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center pt-24 pb-12" data-id="element-432">
        <div className="pt-[70px] py-12 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-[60px] items-center" data-id="element-433">
          <div className="lg:col-span-7 space-y-6" data-id="element-434">
            {/* Main headline section */}
            <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-435">
              <div className="inline-flex items-center border-b border-[#c9a875]/40 pb-1 mb-5 text-xs sm:text-sm" data-id="element-436">
                <span className="text-[#c9a875] font-medium tracking-widest uppercase" data-id="element-437">
                  Transactional Funding for Wholesalers
                </span>
              </div>
              <h1 className="font-serif-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal leading-tight tracking-tight mb-4 sm:mb-6" data-id="element-438">
                <span className="block text-[#2b2826] mb-2 sm:mb-3" data-id="element-439">
                  Scale Your
                </span>
                <div className="flex flex-wrap items-baseline gap-x-3 sm:gap-x-5" data-id="element-440">
                  <span className="text-[#c9a875] italic" data-id="element-441">Wholesaling</span>
                  <span className="text-[#2b2826]" data-id="element-442">Business</span>
                </div>
              </h1>
              <p className="text-lg sm:text-xl text-[#2b2826]/70 mb-6 sm:mb-8 max-w-2xl leading-relaxed font-light" data-id="element-443">
                EMD funding, double closing & stack method solutions with no
                credit checks, same-day approval, and zero paperwork hassle.
              </p>
            </div>

            {/* Feature highlight */}
            <div className={`transition-all duration-1000 delay-300 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-444">
              <div className="h-16 relative mb-4 sm:mb-6" data-id="element-445">
                {features.map((feature, index) => <div key={index} className={`absolute inset-0 flex items-center transition-all duration-500 ${index === activeFeature ? 'opacity-100 transform-none' : 'opacity-0 translate-y-4'}`} style={{
                display: index === activeFeature ? 'flex' : 'none'
              }} data-id="element-446">
                    <div className="bg-white/80 backdrop-blur-sm border border-[#d9d3cb] rounded-full py-2.5 px-4 sm:py-3 sm:px-5 flex items-center shadow-sm max-w-full overflow-hidden" data-id="element-447">
                      <div className="mr-3 p-1.5 sm:p-2 rounded-full bg-[#c9a875]/15 flex-shrink-0" data-id="element-448">
                        {feature.icon}
                      </div>
                      <span className="text-base sm:text-lg text-[#2b2826] font-medium whitespace-nowrap overflow-hidden text-ellipsis" data-id="element-449">
                        {feature.text}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Stats section */}
            <div className={`transition-all duration-1000 delay-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-450">
              <div className="grid grid-cols-3 gap-2 sm:gap-6 border-t border-[#d9d3cb] pt-6" data-id="element-451">
                <div className="flex flex-col" data-id="element-452">
                  <div className="text-sm sm:text-xl md:text-2xl font-serif-display text-[#2b2826] mb-1" data-id="element-453">
                    $<CountUp end={1.2} decimals={1} data-id="element-454" />M
                  </div>
                  <span className="text-[10px] sm:text-xs text-[#2b2826]/60 uppercase tracking-wider font-medium" data-id="element-455">
                    Deployed
                  </span>
                </div>
                <div className="flex flex-col border-l border-[#d9d3cb] pl-4 sm:pl-6" data-id="element-456">
                  <div className="text-sm sm:text-xl md:text-2xl font-serif-display text-[#2b2826] mb-1" data-id="element-457">
                    100%
                  </div>
                  <span className="text-[10px] sm:text-xs text-[#2b2826]/60 uppercase tracking-wider font-medium" data-id="element-458">
                    Satisfaction
                  </span>
                </div>
                <div className="flex flex-col border-l border-[#d9d3cb] pl-4 sm:pl-6" data-id="element-459">
                  <div className="text-sm sm:text-xl md:text-2xl font-serif-display text-[#2b2826] mb-1" data-id="element-460">
                    <CountUp end={148} data-id="element-461" />
                  </div>
                  <span className="text-[10px] sm:text-xs text-[#2b2826]/60 uppercase tracking-wider font-medium" data-id="element-462">
                    Deals Closed
                  </span>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className={`transition-all duration-1000 delay-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'} mt-6 sm:mt-8`} data-id="element-463">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-464">
                <a href="#funding-form" className="flex-1 bg-[#c9a875] text-white font-medium py-3 px-5 sm:py-3.5 sm:px-6 rounded-full hover:bg-[#b08e5c] transition-all shadow-lg hover:shadow-[#c9a875]/25 transform hover:scale-[1.02] group flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#c9a875]/50 focus:ring-offset-2 focus:ring-offset-[#f2efeb]" data-id="element-465">
                  Apply for Funding
                  <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-466" />
                </a>
                <a href="#services" className="flex-1 bg-transparent text-[#2b2826] font-medium py-3 px-5 sm:py-3.5 sm:px-6 rounded-full border border-[#2b2826]/30 hover:bg-[#2b2826] hover:text-[#f2efeb] transition-all flex items-center justify-center group focus:outline-none focus:ring-2 focus:ring-[#2b2826]/30 focus:ring-offset-2 focus:ring-offset-[#f2efeb]" data-id="element-467">
                  Learn More
                </a>
              </div>
            </div>
          </div>

          {/* Form column */}
          <div id="funding-form" className="lg:col-span-5 relative" data-id="element-468">
            <div className={`transition-all duration-1000 delay-300 transform ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'}`} data-id="element-469">
              <div className="relative" data-id="element-470">
                <FundingForm data-id="element-471" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};